import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useWorkspaceTypes } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

interface Props extends Omit<SelectProps<number | number[]>, 'items' | 'onSelect'> {
  onChange?: (value: number | number[]) => void
}
const WorkspaceTypeSelect = (props: Props) => {
  const { onChange, value, ...otherProps } = props
  const workspaceTypes = useWorkspaceTypes({})

  const items = workspaceTypes.data
    ?.sort((a, b) => a.name?.localeCompare(b.name || '') || 0)
    .map((workspace) => ({
      value: workspace.id,
      title: workspace.name,
    }))

  return (
    <Select
      value={value}
      style={styles.container}
      onSelect={onChange}
      items={items}
      disabled={workspaceTypes.isFetching}
      testID="WorkspaceTypeSelect.Container"
      {...otherProps}
    />
  )
}

export default WorkspaceTypeSelect
